import React, { useState, useEffect } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, { SelectProductWithError } from "../../../../Components/Utils/Select";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import axiosInstance from "../../../../Services/axiosCommon";

import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import MultiSelect, { MultiSelectTwo } from "../../../../Components/Utils/MultiSelect";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useToast } from "../../../../Components/Others/ToastServices";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import EditIcon from "../../../../Components/Icons/Edit";
import UseSupplierDropDownNew from "../../../../Components/Hooks/useSupplierSearch";
import DeleteIcon from "../../../../Components/Icons/Delete";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Select from "react-select";

import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateFireExtinguisher() {
  const { data: user } = UseDropDown(`/user/new-drop-down`);
const { data: contract } = UseDropDown(`/contract/drop-down`);
  const { isLoading, Oncancel, addFormData, contextHolder } = useAddFormData();
  const [searchSupplier, setSearchSupplier] = useState("");

   const { data: client, setDataCustomer } = UseCustomerDropDownNew(
      "/clients/drop-down",
      // searchClient
    );

    const { value: Approved, getData: refApproved } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Approved_FireExtinguisher"
    );

     const { value: unit,getData:refunit } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "unit_equipments"
      );

       const { value: industry, getData: refindustry } = useFetchMataData(
          `/dropdown/dropdown-details/`,
          "industry"
        );
      
        const { value: Rating, getData: refRating } = useFetchMetaStar(
          `/dropdown/dropdown-details/`,
          "ratings"
        );
        
         const { value: brand,getData:refbrand } = useFetchMataData(
            `/dropdown/dropdown-details/`,
            "brand_equipments"
          );

          const { value: designation, getData: refdesignation } = useFetchMataData(
              `/dropdown/dropdown-details/`,
              "Designation_Client"
            );

       const [isEditable, setIsEditable] = useState(false);
      
          const [searchequipment, setSearchequipment] = useState("");
    
 
    const [items, setItems] = useState([]);

       const [showPopup, setShowPopup] = useState(false);
    

     const { data: Item , setDataequipments ,setData} = UseProductDropDownNew(
    
        "/equipments/drop-down",
        searchequipment
      );
      const [newItemData, setNewItemData] = useState({
        equipmentName:"",
       unit:"",
       sno:"",
       quantity:""
      });
  
  const toast = useToast();

  const [createNew, setCreateNew] = useState({
            type:1,
          contractId :"", 
          deliveredOn:"",
          deliveredBy:"",
          collectedOn:"",
          equipments :[] ,
          collectors:[],
          attachments:[],
          approvedBy:"",
          countryCode:"",
          phone:"",
        equipmentName:"", 

  });

  const [isEditQua, setIsEditQua] = useState(false);

        const [sortedProList,setSortedProList] =  useState([]);

              const [isEditUnit, setIsEditUnit] = useState(false);
              const [error, setError] = useState("");
              const [productError, setProductError] = useState("");
              const [unitError, setUnitError] = useState("");
              const [quantityError, setQuantityError] = useState("");
              const handleAdd = () => {
                let hasError = false;
            
                if (!formik.values.equipmentName) {
                  setProductError("Product is required");
                  hasError = true;
                } else {
                  setProductError("");
                }
            
                if (!formik.values.unit) {
                  setUnitError("Unit is required");
                  hasError = true;
                } else {
                  setUnitError("");
                }
            
                if (!formik.values.quantity) {
                  setQuantityError("Quantity is required");
                  hasError = true;
                } else {
                  setQuantityError("");
                }
            
                if (hasError) return;
            
                if (formik.values.equipmentName && formik.values.quantity) {
                  const selectedProduct = Item.find(
                    (i) => i.value === formik.values.equipmentName
                  );
                  const newItem = {
                    equipmentName: formik.values.equipmentName,
                    productName: sortedProList.find((i) => i.value === formik.values.equipmentName),
                    quantity: formik.values.quantity,
                    // unit:selectedProduct.unit
                    unit: formik.values.unit,
                  };
                  setItems([...items, newItem]);
            
                  setNewItemData({
                    equipmentName:"",
               unit:"",
               sno:"",
               quantity:""
                  });
                  let updatedItems = Item.filter(
                    (it) => it.value !== formik.values.equipmentName
                  );
                  setData(updatedItems);
                  formik.values.equipmentName = "";
                  formik.values.quantity = "";
                  formik.values.unit = "";
                  setError("");
                }
              };
            
            
              // const handleProductUnitChange = (value, index) => {
              //   const updatedItems = items.map((item, idx) => {
              //     if (idx === index) {
              //       return { ...item, unit: value?.value };
              //     }
              //     return item;
              //   });
              //   setItems(updatedItems);
              // };
            

               const handlePopupSubmit = async (e) => {
                   e.preventDefault();
                   
               
                   const formData = new FormData();
                   formData.append(
                     "json_data",
                     JSON.stringify({
                      
                       companyName: formik.values.companyName || "",
                       email: formik.values.email || "",
                       industry: formik.values.industry || "",
                        category: formik.values.category || "",    
                        pcName:formik.values.pcName ||"",
                        pcDesignation:formik.values.pcDesignation ||"",
                        pcCountryCode:formik.values.pcCountryCode ||"",
                        pcMobile:formik.values.pcMobile ||"",
                        phone:formik.values.phone ||"",
                        phoneCC:formik.values.phoneCC ||"",
                        ratings:formik.values.ratings ||"",
              
                     })
                   );
                   try {
                     const response = await axiosInstance.post(
                       "/clients/new-client",
                       formData
                     );
                         const createdAgent = response.data?.data;
               
                         setDataCustomer((prevCustomers) => [
                           {
                             label: formik.values.companyName || "-",
                             value: createdAgent
                           },...prevCustomers
                         ]);
                         resetForm();
                   } catch (error) {
                     console.error("Error creating new customer:", error);
                   }
                 };

                  const handlePopupSubmitEquipmt = async (e) => {
                      e.preventDefault();
                      
                  
                      const formData = new FormData();
                      formData.append(
                        "json_data",
                        JSON.stringify({
                         
                          name: formik.values.name || "",
                          brand: formik.values.brand || "",
                          unit: formik.values.unit || "",
                           model: formik.values.model || "",
                     
                        
                        })
                      );
                      try {
                        const response = await axiosInstance.post(
                          "/equipments/new-equipment",
                          formData
                        );
                            const createdEquipt = response.data?.data;
                  
                            setData((prevEquipments) => [
                              {
                                label: formik.values.name || "-",
                                value: createdEquipt
                              },...prevEquipments
                            ]);
                            resetFormE();
                      } catch (error) {
                        console.error("Error creating new customer:", error);
                      }
                    };

                     const handleQuantityChange = (e, index) => {
        const updatedQuantity = e.target.value;
    
        // Update the specific item's quantity
        const updatedItems = items.map((item, idx) => {
          if (idx === index) {
            return { ...item, quantity: updatedQuantity };
          }
          return item;
        });
    
        setItems(updatedItems); // Update the state with new quantity
      };
    
      const handleProductUnitChange = (value, index) => {
        const updatedItems = items.map((item, idx) => {
          if (idx === index) {
            return { ...item, unit: value?.value };
          }
          return item;
        });
        setItems(updatedItems);
      };
    
      const handleDeleteItem = (indexToDelete) => {
        const updatedItems = items.filter((_, index) => index !== indexToDelete);
        let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
        setItems(updatedItems);
        let tempDd = ddUpdatedItem.productName;
        setData([...Item, tempDd]);
        // localStorage.setItem("items", JSON.stringify(updatedItems));
      };

                          const [oldData, setOldData] = useState([])
                    

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
         contractId: yup.string().required("ContractId is requred!"),
         clientId: yup.string().required("ClientId is requred!"),
   
       }),
    onSubmit: async (value, { resetForm }) => {
      // if (crlist.length === 0) {
      //   setError("Product table is empty");
      //   return;
      // }

       // if (items.length === 0) {
      //   setError("Equipment table is empty");
      //   return;
      // }
      let formData = new FormData();

      const valueWithItems = {
        ...value,
        // equipments: items,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
            await addFormData({url:`/collection-and-returns/new-cr`, formData:formData,navigateUrl:`/Contract-management/fireExtinguisher`,resetForm:resetForm   });

      // addFormData("/collection-and-returns/new-cr", formData, resetForm);
    },
  });

  const [crlist, setcrlist] = useState([]);

  const getcr = (contractId) => {
    if (contractId !== "") {
      axiosInstance
        .get(`/contract/equipments/${contractId}`)
        .then((res) => {
          let data = res.data;
          setcrlist(data);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  // const getCustomerRef = (contractId) => {
  //   if (contractId !== "") {
  //     axiosInstance
  //       .get(`/rfq/customer-ref/${contractId}`)
  //       .then((res) => {
  //         let data = res.data.data;
  //         formik?.setFieldValue("customerRfq", data);
  //       })
  //       .catch((err) => {
  //         console.log(err, "err");
  //       });
  //   }
  // };

  // useEffect(() => {
  //   if (crlist.length > 0) {
  //     setError("");
  //   }
  // }, [crlist]);

  useEffect(() => {
    if (formik.values.contractId) {
      getcr(formik.values.contractId);
    }
    // if (formik.values.contractId) {
    //   getCustomerRef(formik.values.contractId);
    // }
  }, [formik.values.contractId]);

  const [deletedItem, setDeletedItem] = useState([]);
  const [deletedItemDropDown, setDeletedItemDropDown] = useState([]);

  // const handleDeleteItem = (indexToDelete) => {
  //   const updatedItems = crlist.filter((_, index) => index !== indexToDelete);
  //   setcrlist(updatedItems);
  //   const deletedItems = crlist.filter((_, index) => index == indexToDelete);
  //   setDeletedItem((prevDeletedItems) => [
  //     ...prevDeletedItems,
  //     ...deletedItems,
  //   ]);
  // };
  useEffect(() => {
    let tempData = [];
    deletedItem.forEach((item) => {
      let tempObject = { value: item.productId, label: item.product_name };
      tempData.push(tempObject);
    });
    setDeletedItemDropDown(tempData);
  }, [deletedItem]);

  // const handleAdd = () => {
  //   const selectedProductId = formik.values.productId;

  //   const selectedProduct = deletedItem.find(
  //     (item) => item.productId === selectedProductId
  //   );

  //   if (selectedProduct) {
  //     setcrlist((prevcrlist) => [...prevcrlist, selectedProduct]);

  //     setDeletedItem((prevDeletedItems) =>
  //       prevDeletedItems.filter((item) => item.productId !== selectedProductId)
  //     );
  //   }
  // };



  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
   const [showPopupEquipment, setShowPopupEquipment] = useState(false);

   const togglePopupEqupiment = () => {
     setShowPopupEquipment(!showPopupEquipment);
   };

 function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  // const handleQuantityChange = (e, index) => {
  //   const updatedItems = [...crlist];
  //   updatedItems[index].quantity = e.target.value;
  //   setcrlist(updatedItems);
  // };

  const getCustomerRef = (id) => {
    if (id !== "") {
      axiosInstance
        .get(`/contract/${id}`)
        .then((res) => {
          let data = res.data.data;
          formik?.setFieldValue("clientId", data.clientId);

        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    // if (formik.values.prId) {
    //   getPr(formik.values.prId);
    // }
    if (formik.values.contractId) {
      getCustomerRef(formik.values.contractId);
    }
  }, [formik.values.contractId]);


    const togglePopup = () => {
     setShowPopup(!showPopup);
   };
 
   const resetForm = () => {
    //  formik.values.type = ""
     formik.values.companyName = "";
     formik.values.email = "";
     formik.values.industry = "";
     formik.values.pcName = "";
     formik.values.pcDesignation = "";
     formik.values.pcCountryCode = "";
     formik.values.pcMobile = "";
     formik.values.phoneCC = "";
     formik.values.phone = "";
     formik.values.ratings= "";


      
     setShowPopup(false);
   }

   const resetFormE = () => {
   
     formik.values.name = "";
     formik.values.brand = "";
     formik.values.unit = "";
       formik.values.model = "";
     
     
     setShowPopupEquipment(false);
     console.log("Popup closed");
   }

    useEffect(()=>{
       if(Item){
         const union = Array.from(
           new Map([...Item, ...oldData].map((item) => [item.value, item])).values()
         );
         let data = union.sort((a, b) => a.label.localeCompare(b.label))
         setSortedProList(data)
       }    
     },[Item])

       useEffect(() => {
         if (formik.values.equipmentName) {
           const findValue = sortedProList.filter((v) => formik.values?.equipmentName ==(v.value));
           setOldData(findValue);
         }
         console.log("Testing",formik.values.equipmentName);
       },[formik.values.equipmentName])

       const [Newinspector, setInspector] = useState([]);

  function getContractsByClientId() {
    axiosInstance
      .get(`/team/drop-down`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const formatted = res.data.map(item => ({
            value: item.value,
            label: item.label,
          }));
          setInspector(formatted);
        } else {
          console.error("Unexpected API response format");
          setInspector([]);
        }
      })
      .catch(err => {
        console.error("Error fetching contracts by client ID:", err);
        setInspector([]);
      });
  }

  useEffect(() => {
    getContractsByClientId()
  }, [])

  return (
    <div className="w-full h-full py-2 px-4">
       <div className="flex justify-between w-full">  
       <Breadcrumb
          items={[
 
            
            {
              name: "Fire Extinguisher",
              link:"/Contract-management/fireExtinguisher"

            },

            { name: "Create" },
          ]}
        />       
                <BackButton />
              </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-155px)] bg-white rounded-md overflow-hidden mt-4">
        <div className="w-full ml-3">
                                         <SettingHeading title="Fire Extinguisher"  />
                
              </div>
          <div className="w-full h-full py-4 px-3 flex justify-start content-start flex-wrap overflow-y-auto">
          <FormikSelectTwo
                label="Contract "
                Options={contract}
                formik={formik}
                placeholder="Choose"
                name="contractId"
                isRequired={true}
  
                width="w-full md:w-1/3 "
              />

{formik.values.contractId && (
  <FormikSelectTwo
    label="Client"
    placeholder="Client"
    Options={client}
    formik={formik}
    name="clientId"
    isRequired={true}
    width="w-full md:w-1/3 "
    disabled={true}
  />
)}

<NuDate
                             label="Collected Date"
                             formik={formik}
                             name="collectedOn"
                             width="w-full md:w-1/3 "
                           />
                           

               <MultiSelect
                label="Collected By"
                Options={Newinspector}
                formik={formik}
                placeholder="Collected By"
                name="collectors"
                // isRequired={true}
  
                width="w-full md:w-1/3 "
              />

{/* <DropDownAddMetaData
              label="Approved By"
              placeholder="Choose"
              Options={Approved}
              formik={formik}
              name="approvedBy"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
              getFunc={refApproved}
              displayProperty={"Approved By"}
              propertyName={"Approved_FireExtinguisher"}
              FixPosition={true}
              PortalTarget={false}
            /> */}

               {/* <NuMobileNumber
                               nunCode="countryCode"
                               label="Phone"
                               placeholder="Phone"
                               formik={formik}
                               name="phone"
                               width="w-full md:w-1/2 lg:w-1/3"
                             /> */}

{/* <NuDate
                             label="Return Date"
                             formik={formik}
                             name="deliveredOn"
                             width="w-full md:w-1/3"
                           />

<FormikSelectTwo
                label="Delivered By"
                Options={user}
                formik={formik}
                placeholder="Delivered By"
                name="deliveredBy"
                // isRequired={true}
  
                width="w-full md:w-1/3 "
              /> */}
            {/* <NuInput
              label="Customer Reference"
              type="text"
              formik={formik}
              placeholder="Customer Reference"
              name="customerRfq"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            /> */}
           
          

         

         
         
            {/* <NuTextArea
              label="Comments"
              type="text"
              formik={formik}
              placeholder="Comments"
              name="comments"
              width="w-full md:w-1/2 lg:w-2/3"
              new_width="w-full md:w-1/2 lg:w-2/3"
            /> */}
            <div className="w-full">
                                       <SettingHeading title="Attachments"  />
              
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

            {/* <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
            {deletedItemDropDown.length > 0 ? (
              <div className="w-full flex justify-start gap-2"> */}
                {/* <FormikSelectTwo
                  type="text"
                  label="Product"
                  placeholder="Product"
                  Options={deletedItemDropDown}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                /> */}
                {/* <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button> */}
              {/* </div>
            ) : null} */}
            {/* <div className="w-full bg-white overflow-y-scroll mt-5">
              {error && (
                <p className="text-xs font-semibold text-red-500">{error}</p>
              )}
              <div className="w-full py-2 bg-textColor-main flex justify-between rounded-lg px-6">
                <p className="w-[5%]  text-left  text-white text-xs font-medium">
                  S.No{" "}
                </p>
                <p className="w-[10%] text-left text-white text-xs font-medium">
                Name
                </p>
                <p className="w-[10%] text-left text-white text-xs font-medium">
                Brand
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Model
                </p>
                <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                  Quantity
                  <span
                    className="pl-1 cursor-pointer"
                    onClick={() => {
                      setIsEditQua((prv) => !prv);
                    }}
                  >
                    {isEditQua === true && (
                      <EditIcon width={"14"} height={"14"} color="yellow" />
                    )}
                    {isEditQua === false && (
                      <EditIcon width={"14"} height={"14"} />
                    )}
                  </span>
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Unit
                </p>
                <p className="w-[5%] text-center text-white text-xs font-medium">
                  Action
                </p>
              </div>
              {crlist?.length > 0 ? (
                <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                  {crlist.map((List, index) => (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                        {index + 1}
                      </p>
                      <p className="w-[10%] text-left text-[#606279] text-xs font-light">
                        {List?.name}
                      </p>
                      <p className="w-[10%] text-left text-[#606279] text-xs font-light">
                        {List?.brand}
                      </p>
                      <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                        {List?.model}
                      </p>
                      <p className="w-[20%] text-center text-[#606279] text-xs font-light">
                        <input
                          type="number"
                          className="w-full outline-none text-center"
                          name="quantity"
                          formik={formik}
                          value={List?.quantity || ""}
                          disabled={!isEditQua}
                          onChange={(e) => handleQuantityChange(e, index)}
                        />
                      </p>
                      <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                        {List?.unit}
                      </p>
                    
                      <div className="w-[5%] text-center">
                        <button
                          onClick={() => handleDeleteItem(index)}
                          type="button"
                          className="text-red-500 cursor-pointer ml-4 border-none"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full text-center text-[#93949f]">
                  No Items here
                </div>
              )}
            </div> */}

              {/* <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
                        <div className=" w-full h-full flex justify-start content-start flex-wrap  mb-4">
                          <div className="w-full">
                            <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-baseColor-primary decoration-2 underline-offset-4">
                              Equipments :
                            </p>
                          </div>
                          <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                            <SelectProductWithError
                              type="text"
                              label="Equipment "
                              placeholder="Equipment "
                              Options={sortedProList}
                              formik={formik}
                              name="equipmentName"
                              width="w-full md:w-1/2 lg:w-[67%] z-10"
                              ErrMessage={productError}
                              px="0"
                              handleClick={togglePopupEqupiment}
                              setSearch={setSearchequipment}
                              FixPosition={true}
                              PortalTarget={false}
                            />
                            <DropDownAddUnitWithError
                              label="Unit"
                              placeholder="Choose"
                              Options={unit}
                              formik={formik}
                              name="unit"
                              width="w-full md:w-1/2 lg:w-1/4"
                              getFunc={refunit}
                              displayProperty={"Add Unit"}
                              propertyName={"unit_equipments"}
                              ErrMessage={unitError}
                              FixPosition={true}
                              PortalTarget={false}
                            />
                           
                            <NuInputWithError
                              label="Quantity"
                              type="number"
                              formik={formik}
                              placeholder="Quantity"
                              name="quantity"
                              width="w-full md:w-1/2 lg:w-1/4 "
                              ErrMessage={quantityError}
                            />
                            <button
                              onClick={handleAdd}
                              type="button"
                              className=" p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                            >
                              Add
                            </button>
                          </div>
                         <div className="w-full bg-white overflow-y-scroll mt-5">
              {error && (
                <p className="text-xs font-semibold text-red-500 px-4">{error}</p>
              )}
            
              {/* Desktop Headers */}
              {/* <div className="w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex">
                <p className="w-[5%] text-left text-white text-xs font-medium">S.No</p>
                <p className="w-[55%] text-left text-white text-xs font-medium">Equipment</p>
                <p className="w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                  Unit
                  {/* <span className="pl-1 cursor-pointer" onClick={() => setIsEditUnit((prev) => !prev)}>
                     <EditIcon
                width="14"
                height="14"
                color={isEditUnit ? "#facc15" : "#9ca3af"} // yellow when enabled, gray when disabled
              />
                  </span> */}
                {/* </p>
                <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                  Quantity
                
                </p>
                <p className="w-[5%] text-right text-white text-xs font-medium">Action</p>
                <span className="pl-1 cursor-pointer" onClick={() => setIsEditable(prev => !prev)}>
              <EditIcon
                width="14"
                height="14"
                color={isEditable ? "#facc15" : "#9ca3af"} // Yellow when editable
              />
            </span>
              </div> */} 
            
              
               {/* DESKTOP ROWS */}
            {/* <div className="h-[calc(100vh-300px)] overflow-y-scroll hidden md:block">
              {items.map((List, index) => (
                <div key={index} className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100">
                  <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">{index + 1}</p>
                  <p className="w-[55%] text-left text-xs font-medium text-[#111537] py-2.5">{List?.productName?.label || ""}</p>
                  <p className="w-[15%] text-center pl-4 text-xs font-medium text-[#111537]">
                   <Select
              value={unit.find((item) => item?.value === List?.unit) || null}
              options={isEditable ? unit : []}
              onChange={(value) => handleProductUnitChange(value, index)}
              isDisabled={!isEditable}
            />
                  </p>
                  <p className="w-[20%] text-center text-xs font-medium text-[#111537] py-2.5">
                   <input
              type="number"
              className="w-11/12 mx-auto outline-none text-center"
              value={List?.quantity}
              disabled={!isEditable}
              onChange={(e) => handleQuantityChange(e, index)}
            />
                  </p>
                  <div className="w-[5%] text-right py-2.5">
                    <button
                      onClick={() => handleDeleteItem(index)}
                      type="button"
                      className="text-red-500 cursor-pointer ml-4 border-none"
                    >
                      <DeleteIcon color="red" height={12} />
                    </button>
                  </div>
                </div>
              ))}
            </div> */}
            
            {/* MOBILE CARDS */}
            {/* <div className="md:hidden space-y-4 mt-4 px-4">
              {items.map((List, index) => (
                <div key={index} className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 bg-gray-50">
                  <div><span className="text-xs font-medium text-[#111537]">S.No:</span> {index + 1}</div>
                  <div><span className="text-xs font-medium text-[#111537]">Equipment:</span> {List?.productName?.label || ""}</div>
            
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-medium text-[#111537]">Unit:</span>
                    <span className="cursor-pointer text-xs font-medium text-[#111537]" onClick={() => setIsEditUnit(prev => !prev)}>
                      <EditIcon width="14" height="14" color={isEditUnit ? "#facc15" : "#9ca3af"} />
                    </span>
                  </div>
                  <Select
                    value={unit.find((item) => item?.value === List?.unit) || null}
                    options={isEditUnit ? unit : []}
                    onChange={(value) => handleProductUnitChange(value, index)}
                    isDisabled={!isEditUnit}
                  />
            
                  <div className="flex justify-between items-center pt-2">
                    <span className="text-xs font-medium text-[#111537]">Quantity:</span>
                    <span className="cursor-pointer text-xs font-medium text-[#111537]" onClick={() => setIsEditQua(prev => !prev)}>
                      <EditIcon width="14" height="14" color={isEditQua ? "#facc15" : "#9ca3af"} />
                    </span>
                  </div>
                  <input
                    type="number"
                    className="w-full border px-2 py-1 rounded text-xs"
                    value={List?.quantity}
                    disabled={!isEditQua}
                    onChange={(e) => handleQuantityChange(e, index)}
                  />
            
                  <div className="text-right">
                    <button
                      onClick={() => handleDeleteItem(index)}
                      type="button"
                      className="text-red-500 text-xs mt-2"
                    >
                      <DeleteIcon color="red" height={12} />
                    </button>
                  </div>
                </div>
              ))}
            </div> */}
            
            
            {/* </div>
            
                   
                          
                        
                        </div>
                      </div> */} 
            <div className="w-full mx-auto my-4 mt-8 pb-2">
              <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
     
      {/* {showPurchaserPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">
              Add Local Purchaser
            </h2>
            <form onSubmit={handlePopupPurchaserSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Name"
                  placeholder="Enter Name"
                  formik={formik}
                  name="name"
                  isRequired={true}
                  width="w-full md:w-1/3 md:-mt-2"
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  isRequired={true}
                  width="w-full md:w-1/3 md:-mt-2"
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  width="w-full md:w-1/3 md:-mt-2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePurchaserPopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )} */}

       {showPopup && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
                  <form onSubmit={handlePopupSubmit}>
                    <div className="mb-4 flex flex-wrap">
                     
                      <NuInput
                        type="text"
                        label="Company "
                        placeholder="Company "
                        formik={formik}
                        name="companyName"
                        width="w-full md:w-1/2 lg:w-1/2"
                        isRequired={true}
                      />
                    
                      <NuInput
                        type="email"
                        label="Email"
                        placeholder="Email"
                        formik={formik}
                        name="email"
                        width="w-full md:w-1/2 lg:w-1/2"
                        isRequired={true}
                      />
                        <NuMobileNumber
                                    nunCode="countryCode"
                                    label="Phone"
                                    placeholder="Phone"
                                    formik={formik}
                                    name="phone"
                                    isRequired={true}
                                    FixPosition={true}
                                    PortalTarget={false}
                                    width="w-full md:w-1/2 lg:w-1/2"
                                  />
                       <DropDownAddMetaData
                                      type="text"
                                      label="Industry"
                                      placeholder="Industry"
                                      Options={industry}
                                      formik={formik}
                                      name="industry"
                                      width="w-full md:w-1/2 lg:w-1/2"
                                      displayProperty={"Industry"}
                                    propertyName={"industry"}
                                    getFunc={refindustry}
                                    FixPosition={true}
                                    PortalTarget={false}
                      
                                      
                                    />
      
                                    <FormikSelectTwo
                                                    Options={Rating}
                                                    label=" Ratings"
                                                    placeholder=" Ratings"
                                                    formik={formik}
                                                    name="ratings"
                                                    width="w-full md:w-1/2 lg:w-1/3"
                                                  />
                       <div className="w-full">
                      <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                       Primary Contact :
                      </p>
                    </div>
                    <NuInput
                    type="text"
                    label="Contact Person "
                    placeholder="Contact Person "
                    formik={formik}
                    name="pcName"
                    isRequired={true}
                    width="w-full md:w-1/2 lg:w-1/2"
                  />
      
                    <DropDownAddMetaData
                      type="text"
                      label="Designation"
                      placeholder="Designation"
                      Options={designation}
                      formik={formik}
                      name="pcDesignation"
                      width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                      isRequired={true}
                      displayProperty={"Designation"}
                    propertyName={"Designation_Client"}
                    getFunc={refdesignation}
                    FixPosition={true}
                    PortalTarget={false}
      
                      
                    />
      
                    <NuMobileNumber
                    nunCode="pcCountryCode"
                    label="Phone"
                    placeholder="Phone"
                    formik={formik}
                    name="pcMobile"
                    isRequired={true}
                    width="w-full md:w-1/2 lg:w-1/2"
                    FixPosition={true}
                    PortalTarget={false}
                  />
      
                    <NuInput
                    type="email"
                    label="Email"
                    placeholder="Email"
                    formik={formik}
                    name="pcEmail"
                    isRequired={true}
                    width="w-full md:w-1/2 lg:w-1/2"
                  />
      
                 
                      
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePopup}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                                                      <SubmitButton isLoading={isLoading} />
                      
                    </div>
                  </form>
                </div>
              </div>
            )}
             {showPopupEquipment && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
                  <form onSubmit={handlePopupSubmitEquipmt}>
                    <div className="mb-4 flex flex-wrap">
                     
                    <NuInput
                      label="Name"
                      placeholder="Name"
                      formik={formik}
                      name="name"
                      width="w-full"
                      new_width="w-full"
        
                    />
                    <DropDownAddMetaData
                                  label="Unit"
                                  placeholder="Choose"
                                  Options={unit}
                                  formik={formik}
                                  name="unit"
                                  width="w-full "
                                  getFunc={refunit}
                                  displayProperty={"Unit"}
                                  propertyName={"unit_equipments"}
                                  FixPosition={false}
                                  PortalTarget={false}
                      isRequired={true}
        
                                />
                                <DropDownAddMetaData
                                  label="Brand"
                                  placeholder="Choose"
                                  Options={brand}
                                  formik={formik}
                                  name="brand"
                                  width="w-full "
                                  getFunc={refbrand}
                                  displayProperty={"Brand"}
                                  propertyName={"brand_equipments"}
                                  FixPosition={false}
                                  PortalTarget={false}
                      isRequired={true}
        
                                />
                     <NuInput
                      label="Model no"
                      placeholder="Model no"
                      formik={formik}
                      name="model"
                      width="w-full"
                      new_width="w-full"
        
                    />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePopupEqupiment}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                                                     <SubmitButton isLoading={isLoading} />
                     
                    </div>
                  </form>
                </div>
              </div>
            )}
    </div>
  );
}

export default CreateFireExtinguisher;
